import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";
function connectToSocket() {
  const publicToken = localStorage.getItem("publicToken");
  const socket = openSocket(getBackendUrl(), {
      query: {
          publicToken: JSON.parse(publicToken),
      },
  });

  return socket;
}

export default connectToSocket;
